module.exports = __webpack_public_path__ + "static/media/vbox.0e9e8c03.png";